"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var sdk = require("microsoft-cognitiveservices-speech-sdk");

var audioUtils = require("./audioUtils");

function Recorder(config) {
  var _this = this;

  config = config || {};
  var self = this;
  var transcription = "";
  var sampleRate;
  var audioInput;
  var audioNode;
  var bufferSize = config.bufferSize || 4096;
  var recordedData = [];
  var recording = false;
  var recordingLength = 0;
  var audioCtx;
  var azure_recognizer;
  var auth_token = false;
  var language = false;
  var brand = false;
  this.wave = config.visualize;
  this.transcript = '';

  this.get_auth_token = function () {
    return fetch('https://xorfrexjm8.execute-api.eu-west-2.amazonaws.com/Prod/get_azure_stt_token' + (_this.brand ? '?brand=' + _this.brand : ''), {
      method: "GET"
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(console.error);
      }

      return response.json();
    }).then(function (token) {
      return new Promise(function (res) {
        auth_token = token;
        return res(token);
      });
    });
  };

  var getLanguage = function getLanguage() {
    var output = ["fr-FR", "en-US", "es-ES"];
    var all = ["ar-BH", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LB", "ar-OM", "ar-QA", "ar-SA", "ar-SY", "ar-AE", "bg-BG", "ca-ES", "zh-HK", "zh-CN", "zh-TW", "hr-HR", "cs-CZ", "da-DK", "nl-NL", "en-US", "en-AU", "en-CA", "en-HK", "en-IN", "en-IE", "en-NZ", "en-PH", "en-SG", "en-ZA", "en-GB", "et-EE", "fi-FI", "fr-FR", "fr-CA", "de-DE", "el-GR", "gu-IN", "hi-IN", "hu-HU", "ga-IE", "it-IT", "ja-JP", "ko-KR", "lv-LV", "lt-LT", "mt-MT", "mr-IN", "nb-NO", "pl-PL", "pt-BR", "pt-PT", "ro-RO", "ru-RU", "sk-SK", "sl-SI", "es-ES", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-CU", "es-DO", "es-EC", "es-SV", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PY", "es-PE", "es-PR", "es-UY", "es-US", "es-VE", "sv-SE", "ta-IN", "te-IN", "th-TH", "tr-TR"];
    var lgs = navigator.languages;

    var _iterator = (0, _createForOfIteratorHelper2.default)(lgs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var lg = _step.value;

        if (all.includes(lg)) {
          if (!output.includes(lg)) {
            output.push(lg);
          }

          return output;
        }

        var all_2 = all.map(function (x) {
          return x.substring(0, 2);
        });
        var lg_2 = lg.substring(0, 2);

        if (all_2.includes(lg_2)) {
          var lg_n = all[all_2.indexOf(lg_2)];

          if (!output.includes(lg_n)) {
            output.push(lg_n);
          }

          return output;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return output;
  };

  var setRecogniser = function setRecogniser(token) {
    var speechConfig = sdk.SpeechConfig.fromAuthorizationToken(token, "westeurope"); // A REVOIR POUR INTEGRER LA LANGUE DU NAVIGATEUR
    //const autoDetectConfig = sdk.AutoDetectSourceLanguageConfig.fromOpenRange();

    var autoDetectConfig = sdk.AutoDetectSourceLanguageConfig.fromLanguages(getLanguage());
    var pushStream = sdk.AudioInputStream.createPushStream();
    var audioConfig = sdk.AudioConfig.fromStreamInput(pushStream);
    speechConfig.speechRecognitionLanguage = 'fr-FR';

    if (window.modelEndpointId) {
      speechConfig.endpointId = "e8c3d4eb-10cc-4c85-b43c-9654bf5c1d04";
      azure_recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
    } else {
      azure_recognizer = sdk.SpeechRecognizer.FromConfig(speechConfig, autoDetectConfig, audioConfig);
    }

    var onRecordingFunct = function onRecordingFunct(rawAudioChunk) {
      var raw = rawAudioChunk.detail; ////console.log('Mic Raw', raw)

      if (raw == null) return; // downsample and convert the raw audio bytes to PCM

      var downsampledBuffer = audioUtils.downsampleBuffer(raw, sampleRate);
      var pcmEncodedBuffer = audioUtils.pcmEncode(downsampledBuffer);
      pushStream.write(pcmEncodedBuffer);
    };

    document.addEventListener('onRecording', onRecordingFunct, false);

    azure_recognizer.recognizing = function (s, e) {//console.log(`RECOGNIZING: Text=${e.result.text}`);
    };

    azure_recognizer.recognized = function (s, e) {
      if (!window.modelEndpointId) {
        language = sdk.AutoDetectSourceLanguageResult.fromResult(e.result)['privLanguage'];
      } else {
        language = "fr-FR";
      } //console.log(sdk.AutoDetectSourceLanguageResult.fromResult(e.result))
      //console.log(e.result.language)


      console.log("Finisher, RECOGNIZED: Text=".concat(e.result.text));

      if (e.result.text !== undefined) {
        transcription += e.result.text + '\n';
      }

      if (e.result.reason == sdk.ResultReason.RecognizedSpeech) {//console.log(`RECOGNIZED: Text=${e.result.text}`);
      } else if (e.result.reason == sdk.ResultReason.NoMatch) {//console.log("NOMATCH: Speech could not be recognized.");
      }
    };

    azure_recognizer.canceled = function (s, e) {
      //console.log(`CANCELED: Reason=${e.reason}`);
      if (e.reason == sdk.CancellationReason.Error) {//console.log(`"CANCELED: ErrorCode=${e.errorCode}`);
        //console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`);
        //console.log("CANCELED: Did you update the subscription info?");
      }

      document.removeEventListener('onRecording', onRecordingFunct);
      azure_recognizer.stopContinuousRecognitionAsync();
    };

    azure_recognizer.sessionStopped = function (s, e) {
      //console.log(e, s)
      //console.log("\n    Session stopped event.");
      azure_recognizer.stopContinuousRecognitionAsync();
      _this.transcript = transcription;
      document.removeEventListener('onRecording', onRecordingFunct);
    };

    azure_recognizer.startContinuousRecognitionAsync();
  };

  this.toggleRecording = function () {
    //console.log(recording)
    return recording ? self.stop() : self.start();
  };

  this.start = function () {
    // reset any previous data
    recordedData = [];
    recordingLength = 0; // webkit audio context shim

    audioCtx = new (window.AudioContext || window.webkitAudioContext)();

    if (audioCtx.createJavaScriptNode) {
      audioNode = audioCtx.createJavaScriptNode(bufferSize, 1, 1);
    } else if (audioCtx.createScriptProcessor) {
      audioNode = audioCtx.createScriptProcessor(bufferSize, 1, 1);
    } else {
      throw 'WebAudio not supported!';
    }

    audioNode.connect(audioCtx.destination);
    navigator.mediaDevices.getUserMedia({
      audio: true
    }).then(function (d) {
      /*.catch(function (error) {
          //console.log('There was an error streaming your audio to Amazon Transcribe. Please try again.');
          toggleStartStop();
      });*/
      onMicrophoneCaptured(d);

      var wait_for_token = function wait_for_token() {
        if (auth_token) {
          setRecogniser(auth_token);
        } else {
          setTimeout(wait_for_token, 200);
        }
      };

      wait_for_token(); //Part of the transcribe
    }); //.catch(onMicrophoneError);
  };

  this.stop = function (cancel) {
    var _this2 = this;

    //console.log(1)
    return new Promise(function (res, rej) {
      //console.log(2)
      if (cancel) {//console.log('Canceled')
      } else {//console.log('stopContinuousRecognitionAsync')
      }

      azure_recognizer.stopContinuousRecognitionAsync(function () {
        stopRecording(function (blob) {
          //console.log(3)
          self.blob = blob;
          config.onRecordingStop && config.onRecordingStop(blob); //console.log(4)

          if (!language) {
            return rej({
              "en": "There was an error with the recognition!",
              "fr": "Il y a eu une erreur avec la reconnaissance !"
            });
          }

          fetch('https://bdcgo3u5t6.execute-api.eu-west-2.amazonaws.com/prod/', {
            method: 'POST',
            body: JSON.stringify({
              "text": _this2.transcript,
              "language": language.substring(0, 2)
            })
          }).then(function (resp) {
            if (!resp.ok) {
              transcription = '';
              res({
                text: _this2.transcript,
                sentiment: 'NEUTRAL',
                language: language
              });
            }

            return resp.json();
          }).then(function (resp) {
            transcription = ''; //console.log(resp)

            res({
              text: _this2.transcript,
              sentiment: resp['sentiment'],
              language: language
            });
          });
        });
      });
    });
  };

  this.upload = function (url, params, callback) {
    var formData = new FormData();
    formData.append("audio", self.blob, config.filename || 'recording.wav');

    for (var i in params) {
      formData.append(i, params[i]);
    }

    var request = new XMLHttpRequest();
    request.upload.addEventListener("progress", function (e) {
      callback('progress', e, request);
    });
    request.upload.addEventListener("load", function (e) {
      callback('load', e, request);
    });

    request.onreadystatechange = function (e) {
      var status = 'loading';

      if (request.readyState == 4) {
        status = request.status == 200 ? 'done' : 'error';
      }

      callback(status, e, request);
    };

    request.open("POST", url);
    request.send(formData);
  };

  function stopRecording(callback) {
    // stop recording
    recording = false; // to make sure onaudioprocess stops firing

    window.localStream.getTracks().forEach(function (track) {
      track.stop();
    });
    audioInput.disconnect();
    audioNode.disconnect();
    exportWav({
      sampleRate: sampleRate,
      recordingLength: recordingLength,
      data: recordedData
    }, function (buffer, view) {
      self.blob = new Blob([view], {
        type: 'audio/wav'
      });
      callback && callback(self.blob);
    });
  }

  function onMicrophoneCaptured(microphone) {
    recording = true; // save the stream so we can disconnect it when we're done

    window.localStream = microphone;
    audioInput = audioCtx.createMediaStreamSource(microphone);
    audioInput.connect(audioNode); ////console.log(audioInput)
    //audioInput.connect(audioCtx.createGain());

    if (config.visualizer) visualize(microphone);
    audioNode.onaudioprocess = onAudioProcess;
    self.startDate = new Date();
    config.onRecordingStart && config.onRecordingStart();
    sampleRate = audioCtx.sampleRate;
  }

  function onMicrophoneError(e) {
    //console.log(e);
    alert('Unable to access the microphone.');
  }

  function onAudioProcess(e) {
    if (!recording) {
      return;
    }

    recordedData.push(new Float32Array(e.inputBuffer.getChannelData(0)));
    var event = new CustomEvent('onRecording', {
      'detail': e.inputBuffer.getChannelData(0)
    });
    document.dispatchEvent(event);
    recordingLength += bufferSize;
    self.recordingLength = recordingLength;
    self.duration = new Date().getTime() - self.startDate.getTime();
    config.onRecording && config.onRecording(self.duration);
  }

  function visualize(stream) {
    var analyser = audioCtx.createAnalyser();
    analyser.fftSize = 2048 / 2;
    var bufferLength = analyser.fftSize;
    var dataArray = new Uint8Array(bufferLength);
    var biquadFilter = audioCtx.createBiquadFilter();
    audioInput.connect(biquadFilter);
    biquadFilter.connect(analyser);
    analyser.fftSize = 2048 / 2;
    var bufferLength = analyser.fftSize;
    var dataArray = new Uint8Array(bufferLength);

    var draw = function draw() {
      analyser.getByteTimeDomainData(dataArray);
      var volume1 = 0;
      var volume2 = 0;

      for (var v in dataArray) {
        if (v > 512) {
          volume1 += dataArray[v];
        } else {
          volume2 += dataArray[v];
        }
      }

      volume1 = volume1 / 512;
      volume2 = volume2 / 512;
      var coef = navigator.userAgent.includes('iPhone OS') ? 20 : 5;
      var scale1 = 1 + coef * (1 - volume1 / 128);
      var scale2 = 1 + coef * (1 - volume2 / 128);

      if (self.wave && self.wave[0] && self.wave[1]) {
        self.wave[0].current.style.transform = 'scale(' + scale1 + ') translate(-50%, -50%)';
        self.wave[1].current.style.transform = 'scale(' + scale2 + ') translate(-50%, -50%)';
      }

      if (!recording) {
        //console.log('STOPPED')
        return;
      }

      setTimeout(draw, 100);
    };

    draw();
  }

  function exportWav(config, callback) {
    function inlineWebWorker(config, cb) {
      var data = config.data.slice(0);
      var sampleRate = config.sampleRate;
      data = joinBuffers(data, config.recordingLength);

      function joinBuffers(channelBuffer, count) {
        var result = new Float64Array(count);
        var offset = 0;
        var lng = channelBuffer.length;

        for (var i = 0; i < lng; i++) {
          var buffer = channelBuffer[i];
          result.set(buffer, offset);
          offset += buffer.length;
        }

        return result;
      }

      function writeUTFBytes(view, offset, string) {
        var lng = string.length;

        for (var i = 0; i < lng; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }

      var dataLength = data.length; // create wav file

      var buffer = new ArrayBuffer(44 + dataLength * 2);
      var view = new DataView(buffer);
      writeUTFBytes(view, 0, 'RIFF'); // RIFF chunk descriptor/identifier

      view.setUint32(4, 44 + dataLength * 2, true); // RIFF chunk length

      writeUTFBytes(view, 8, 'WAVE'); // RIFF type

      writeUTFBytes(view, 12, 'fmt '); // format chunk identifier, FMT sub-chunk

      view.setUint32(16, 16, true); // format chunk length

      view.setUint16(20, 1, true); // sample format (raw)

      view.setUint16(22, 1, true); // mono (1 channel)

      view.setUint32(24, sampleRate, true); // sample rate

      view.setUint32(28, sampleRate * 2, true); // byte rate (sample rate * block align)

      view.setUint16(32, 2, true); // block align (channel count * bytes per sample)

      view.setUint16(34, 16, true); // bits per sample

      writeUTFBytes(view, 36, 'data'); // data sub-chunk identifier

      view.setUint32(40, dataLength * 2, true); // data chunk length
      // write the PCM samples

      var index = 44;

      for (var i = 0; i < dataLength; i++) {
        view.setInt16(index, data[i] * 0x7FFF, true);
        index += 2;
      }

      if (cb) {
        return cb({
          buffer: buffer,
          view: view
        });
      }

      postMessage({
        buffer: buffer,
        view: view
      });
    }

    var webWorker = processInWebWorker(inlineWebWorker);

    webWorker.onmessage = function (event) {
      callback(event.data.buffer, event.data.view); // release memory

      URL.revokeObjectURL(webWorker.workerURL);
    };

    webWorker.postMessage(config);
  }

  function processInWebWorker(_function) {
    var workerURL = URL.createObjectURL(new Blob(["this.onmessage = function (e) {(function (config, cb) {\n            var data = config.data.slice(0);\n            var sampleRate = config.sampleRate;          \n\t\t\tdata = joinBuffers(data, config.recordingLength);\n\t\t\n            function joinBuffers(channelBuffer, count) {\n                var result = new Float64Array(count);\n                var offset = 0;\n                var lng = channelBuffer.length;\n\n                for (var i = 0; i < lng; i++) {\n                    var buffer = channelBuffer[i];\n                    result.set(buffer, offset);\n                    offset += buffer.length;\n                }\n\n                return result;\n            }\n\n            function writeUTFBytes(view, offset, string) {\n                var lng = string.length;\n                for (var i = 0; i < lng; i++) {\n                    view.setUint8(offset + i, string.charCodeAt(i));\n                }\n            }\n\n            var dataLength = data.length;\n\n            // create wav file\n            var buffer = new ArrayBuffer(44 + dataLength * 2);\n            var view = new DataView(buffer);\n\t\t\t\n            writeUTFBytes(view, 0, 'RIFF'); // RIFF chunk descriptor/identifier\n            view.setUint32(4, 44 + dataLength * 2, true); // RIFF chunk length\n            writeUTFBytes(view, 8, 'WAVE'); // RIFF type\n            writeUTFBytes(view, 12, 'fmt '); // format chunk identifier, FMT sub-chunk\n            view.setUint32(16, 16, true); // format chunk length\n            view.setUint16(20, 1, true); // sample format (raw)\n            view.setUint16(22, 1, true); // mono (1 channel)\n            view.setUint32(24, sampleRate, true); // sample rate\n            view.setUint32(28, sampleRate * 2, true); // byte rate (sample rate * block align)\n            view.setUint16(32, 2, true); // block align (channel count * bytes per sample)\n            view.setUint16(34, 16, true); // bits per sample\n            writeUTFBytes(view, 36, 'data'); // data sub-chunk identifier\n            view.setUint32(40, dataLength * 2, true); // data chunk length\n\n            // write the PCM samples\n            var index = 44;\n            for (var i = 0; i < dataLength; i++) {\n                view.setInt16(index, data[i] * 0x7FFF, true);\n                index += 2;\n            }\n\n            if (cb) {\n                return cb({\n                    buffer: buffer,\n                    view: view\n                });\n            }\n\n            postMessage({\n                buffer: buffer,\n                view: view\n            });\n        })(e.data)}"], {
      type: 'application/javascript'
    }));
    var worker = new Worker(workerURL);
    worker.workerURL = workerURL;
    return worker;
  }
}

function convertToUint8Array(float32Array) {
  var output = new Uint8Array(float32Array.length);

  for (var i = 0; i < float32Array.length; i++) {
    var tmp = Math.max(-1, Math.min(1, float32Array[i]));
    tmp = tmp < 0 ? tmp * 0x8000 : tmp * 0x7FFF;
    tmp = tmp * 255;
    output[i] = tmp;
  }

  return output;
}

var _default = Recorder;
exports.default = _default;